<ng-container *notInPopulation="[populations.Pts, populations.Suite, populations.Free]">
  <div class="full-page-container">
    <fgb-banner [title]="'transfer.page.title' | translate"></fgb-banner>

    <div class="d-block d-lg-none">
      <fgb-page-header
        [pageTitle]="'account.page.title'"
        [backButtonLink]="'/'"
        [showQr]="!isSuiteOrPts"
        [showBalance]="!isSuiteOrPts"
      ></fgb-page-header>
    </div>

    <fgb-account-nav></fgb-account-nav>

    <div class="container mt-3">
      <h5 class="ecash-transfer-heading">
        {{ 'ecash.transfer.title' | translate }}
      </h5>
      <div
        class="ecash-transfer-description font-size-14"
        [innerHTML]="'ecash.transfer.description' | translate | markdownTranslate"
      ></div>
      <fgb-partner-bonus-transfer></fgb-partner-bonus-transfer>
    </div>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.Pts, populations.Suite, populations.Free]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
